/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Deleted_RecipeInputs */

const en_session_deleted_recipe = /** @type {(inputs: Session_Deleted_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted recipe`)
};

const de_session_deleted_recipe = /** @type {(inputs: Session_Deleted_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelöschtes Rezept`)
};

/**
* | output |
* | --- |
* | "Deleted recipe" |
*
* @param {Session_Deleted_RecipeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_deleted_recipe = /** @type {((inputs?: Session_Deleted_RecipeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Deleted_RecipeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_deleted_recipe(inputs)
	return en_session_deleted_recipe(inputs)
});